import { Outlet } from 'react-router-dom';
import { CompanyProvider, EmailVerificationGateProvider, UserProvider } from '@lendica/hooks';

export default function CompanyProviderLayout() {
    return (
        <UserProvider>
            <CompanyProvider>
                <EmailVerificationGateProvider>
                    <Outlet />
                </EmailVerificationGateProvider>
            </CompanyProvider>
        </UserProvider>
    );
}
